import { VStack } from '@chakra-ui/react';
import { EmailBlockSection } from '../../../components/EmailBlockSection';
import type { InterviewCommPanelBaseProps } from './types';
import { TemplatedEmail } from '../../../components/TemplatedEmail';

export const AvailabilityCommunicationPanel = ({
  state,
  dispatch,
  fieldErrors,
  submitAttempt,
  availabilityTemplateOptions = [],
  fromOptions,
  ccBccOptions,
  availabilityVariables,
  uploadInlineImage,
  emailApiRefs,
}: InterviewCommPanelBaseProps) => {
  return (
    <VStack align="stretch" spacing="4" w="100%">
      <EmailBlockSection
        title="Candidate availability email"
        sectionId="interview-comm-candidate-availability"
        description="Candidates get this email to share their availability for this interview"
      >
        <TemplatedEmail
          className="w-full"
          showFrom
          showTo={false}
          showSubject
          enableCcBcc
          showTemplate
          showEditor
          editorVariant="richEmail"
          submitAttempt={submitAttempt}
          apiRef={emailApiRefs?.availability}
          variables={availabilityVariables}
          attachments={state.availabilityAttachments}
          onAttachmentsChange={(items) =>
            dispatch({
              type: 'SET_AVAILABILITY_ATTACHMENTS',
              payload: items,
            })
          }
          templateOptions={availabilityTemplateOptions}
          fromOptions={fromOptions}
          ccBccOptions={ccBccOptions}
          applyTemplateBodyToEditor
          value={state.availability}
          onChange={(value) =>
            dispatch({ type: 'SET_AVAILABILITY', payload: value })
          }
          errors={fieldErrors.availability}
          placeholders={{
            from: 'Select from',
            subject: 'Subject',
            template: 'Select a template',
          }}
          uploadInlineImage={uploadInlineImage}
        />
      </EmailBlockSection>
    </VStack>
  );
};
